/**
 * Composer-side state setters for the Uploads Simulator. Pure `setState`
 * wrappers only — localStorage persistence and preset orchestration live on
 * the controller.
 */
class SorComposerDelegate {
    setSor(sor) {
        this.setState({sor});
    }

    /** Replace one top-level SOR section (identity, income, settings, …). */
    setSorSection(sectionKey, value) {
        this.setState({sor: {...this.state.sor, [sectionKey]: value}});
    }

    setSorErrors(sorErrors) {
        this.setState({sorErrors});
    }

    setPresets(presets) {
        this.setState({presets});
    }

    setSelectedPresetName(selectedPresetName) {
        this.setState({selectedPresetName});
    }

    setPresetNotes(presetNotes) {
        this.setState({presetNotes});
    }
}

export default SorComposerDelegate;
